let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8IiKJ")).then(() => parcelRequire('5pL4M'));